import { ApplicationRef, enableProdMode } from '@angular/core';
import { enableDebugTools } from '@angular/platform-browser';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { RecaptchaComponent } from 'ng-recaptcha';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
  platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch((err) => console.error(err));
} else {
  // Todo
  // Run ng.profiler.timeChangeDetection() from chrome devtools console tab, this will give you change detection cycles
  // normally change detection cycles should be less than 16ms to keep Angular application fast enough
  platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .then((module) =>
      enableDebugTools(module.injector.get(ApplicationRef).components[0])
    )
    .catch((err) => console.error(err));
}

RecaptchaComponent.prototype.ngOnDestroy = function () {
  if (this.subscription) {
    this.subscription.unsubscribe();
  }
};
